import React, { useState } from 'react'
import Input from './Input'
import { useDispatch, useSelector } from 'react-redux'
import { RootReducer } from '../redux/rootReducer'
import { SIGN_IN } from '../redux/authReducer'
import ButtonWithLoader from './ButtonWithLoader'
import { Link } from 'react-router-dom'

const SignInScreen = () => {
  const isLoading = useSelector((state: RootReducer) => state.authReducer.isLoading)
  const dispatch = useDispatch()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const submitError = useSelector((state: RootReducer) => state.authReducer.submitError)

  return (
    <div className="overflow-hidden bg-coolGray h-screen">
      <div className="relative z-1">
        <div className="md:h-[7.5rem] h-[0px]" />
        <div className="flex items-center justify-center">
          <div className="max-w-[30rem] flex-1 bg-slateGray p-8 rounded-2xl mx-2 md:mx-0">
            <h4 className="text-36 font-domine text-center text-white">Sign In</h4>
            <p className="text-lightIceBlue font-sans text-center text-18">Get Started!</p>
            <div className="h-[1rem]" />
            <Input onChange={(e) => setEmail(e.target.value)} name={'email'} label="Your Email" error={submitError} />
            <div className="h-[0.5rem]" />
            <Input
              onChange={(e) => setPassword(e.target.value)}
              name={'password'}
              label="Your Password"
              type="password"
              error={submitError}
            />
            <div className="h-[0.5rem]" />
            <ButtonWithLoader
              onClick={() => dispatch(SIGN_IN({ email, password }))}
              label="SignIn"
              isLoading={isLoading}
            />
            <div className="h-[1rem]" />
            <p className="text-12 font-sans text-lightIceBlue text-center">
              Forgot your password?{' '}
              <Link className="underline" to="/reset-password">
                Reset Password
              </Link>
            </p>
            <div className="h-[0.5rem]" />
            <p className="text-12 font-sans text-lightIceBlue text-center">
              By continuing you agree to our Terms of Service and Privacy Policy
            </p>
          </div>
        </div>
        <div className="md:h-[7.5rem] h-[0px]" />
      </div>
    </div>
  )
}

export default SignInScreen
